/* =========================================================================
   CHARMANTE — Pop-up de bienvenue newsletter -10 % (version Shopify)
   Parcours d'arrivée : bannière cookies d'abord → ce pop-up 2 s après.
   S'affiche UNE SEULE FOIS, sur l'accueil, tant qu'on n'est ni connectée ni
   déjà inscrite. À la validation, l'e-mail est envoyé à Shopify (client tagué
   « newsletter »). Le code -10 % part ensuite par e-mail (automatisation
   Shopify « Bienvenue » à brancher côté admin).
   Textes traduits via window.t / window.CharmanteI18n (pont dans theme.liquid).
   ========================================================================= */
(function () {
  'use strict';
  var C = (window.Charmante = window.Charmante || {});
  var t = window.t || function (k, fb) { return fb == null ? k : fb; };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var K_SUB = 'charmante_newsletter_sub';
  var K_SHOWN = 'charmante_welcome_shown';
  var K_DISMISS = 'charmante_welcome_dismissed';
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function isSubscriber() { return lsGet(K_SUB) === '1'; }
  function isHomepage() { var f = location.pathname.split('/').pop(); return f === '' || f === 'index.html'; }
  function isLoggedIn() { return !!C.loggedIn; }

  var modal = null;
  var closeIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function build() {
    modal = document.createElement('div');
    modal.className = 'nl-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="nl-modal__scrim" data-nl-close></div>' +
      '<div class="nl-modal__box">' +
        '<button class="nl-modal__close" type="button" data-nl-close aria-label="' + t('close_dialog') + '">' + closeIcon + '</button>' +
        '<span class="nl-modal__badge" aria-hidden="true">-10%</span>' +
        '<h2 class="nl-modal__title">' + t('nl_title') + '</h2>' +
        '<p class="nl-modal__desc">' + t('nl_desc_html') + '</p>' +
        '<form class="nl-modal__form" novalidate>' +
          '<input class="input" type="email" required placeholder="' + t('nl_email_placeholder') + '" autocomplete="email" aria-label="' + t('nl_email_label') + '">' +
          '<label class="checkbox nl-modal__optin"><input type="checkbox" data-nl-optin><span class="checkbox__box" aria-hidden="true"></span><span>' + t('nl_optin_html') + '</span></label>' +
          '<p class="nl-modal__err field-msg" aria-live="polite"></p>' +
          '<button class="btn btn--rose btn--block btn--lg" type="submit">' + t('nl_submit_html') + '</button>' +
        '</form>' +
        '<button class="nl-modal__decline" type="button" data-nl-close>' + t('nl_decline') + '</button>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-nl-close]')) close(true); });
    modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); close(true); } });
    modal.querySelector('.nl-modal__form').addEventListener('submit', onSubmit);
  }

  function open() {
    if (!modal) build();
    lsSet(K_SHOWN, '1');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    void modal.offsetWidth;
    modal.classList.add('is-open');
    var f = modal.querySelector('input[type="email"]'); if (f) f.focus();
  }

  function close(dismiss) {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 250);
    if (dismiss) lsSet(K_DISMISS, '1');
  }

  function onSubmit(e) {
    e.preventDefault();
    var email = (modal.querySelector('input[type="email"]').value || '').trim();
    var optin = modal.querySelector('[data-nl-optin]').checked;
    var err = modal.querySelector('.nl-modal__err');
    if (!EMAIL_RE.test(email)) { err.textContent = t('nl_err_email'); return; }
    if (!optin) { err.textContent = t('nl_err_optin'); return; }
    // Inscription réelle côté Shopify (création/maj client avec tag « newsletter »)
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter');
    try { fetch('/contact', { method: 'POST', body: fd }).catch(function () {}); } catch (e2) {}
    lsSet(K_SUB, '1');
    modal.querySelector('.nl-modal__box').innerHTML =
      '<button class="nl-modal__close" type="button" data-nl-close aria-label="' + t('close_dialog') + '">' + closeIcon + '</button>' +
      '<span class="nl-modal__badge" aria-hidden="true">-10%</span>' +
      '<h2 class="nl-modal__title">' + t('nl_success_title_html') + '</h2>' +
      '<p class="nl-modal__desc">' + t('nl_success_desc_html') + '</p>' +
      '<button class="btn btn--rose btn--lg" type="button" data-nl-close>' + t('nl_continue') + '</button>';
  }

  function maybeShow() {
    if (isLoggedIn()) return;                                // connectée → pas de pop-up
    if (isSubscriber()) return;                              // déjà inscrite → jamais
    if (lsGet(K_DISMISS) === '1' || lsGet(K_SHOWN) === '1') return; // déjà vue/refusée → jamais
    if (!isHomepage()) return;                               // accueil uniquement
    var showLater = function () { setTimeout(open, 400); }; // tout de suite après les cookies (le temps que le bandeau parte)
    var ck = C.cookies;
    if (!ck || ck.resolved()) showLater();
    else document.addEventListener('cookies:resolved', showLater, { once: true });
  }

  if (document.readyState === 'complete') maybeShow();
  else document.addEventListener('DOMContentLoaded', maybeShow);
})();
